<template>
  <div class="cms-video-block">
    <div v-if="hasVideo" class="cms-video-content" v-html="block.bodyContent"></div>
    <div v-else class="cms-video-placeholder">
      <span class="cms-video-icon" aria-hidden="true">▶</span>
      <p class="cms-video-placeholder-title">{{ block.title || '视频区块' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasVideo() {
      const content = this.block.bodyContent || ''
      return /<(video|iframe)[\s>]/i.test(content)
    }
  }
}
</script>

<style scoped>
.cms-video-block {
  width: 100%;
}

.cms-video-content >>> video,
.cms-video-content >>> iframe {
  display: block;
  width: 100%;
  max-width: 100%;
  border: 0;
  border-radius: var(--front-radius);
  aspect-ratio: 16 / 9;
}

.cms-video-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 24px;
  background: #eef2f6;
  border-radius: var(--front-radius);
  text-align: center;
}

.cms-video-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
  border-radius: 50%;
  background: var(--primary);
  color: #fff;
  font-size: 20px;
}

.cms-video-placeholder-title {
  margin: 0;
  color: var(--subtle);
  font-size: 14px;
}
</style>
